import gql from 'graphql-tag'
export default gql`mutation deleteResourceMutation($resourceId: Int!) {
  deleteResource(resourceId: $resourceId) {
    success
  }
}`